import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";

const CustomBox = ({
  mt = "",
  mb = "",
  content = "",
  status = "",
  style = {},
}) => {
  const { theme } = useCustomLogic();

  const handleStatusColor = (status) => {
    switch (status) {
      case "yes":
      case "Yes":
      case "YES":
      case "yes proper":
        return "#82b54b";
      case "no":
      case "No":
      case "NO":
      case "yes not proper":
        return "#e04f1a";
      default:
        return "#3c90df";
    }
  };

  return (
    <Box
      display={status && "flex"}
      justifyContent={status && "space-between"}
      alignItems={status && "center"}
      sx={{
        mt: mt || "20px",
        mb: mb && mb,
        width: "100%",
        backgroundColor: style.backgroundColor || "#F1f1f1",
        // padding: '0px',
      }}
    >
      <Typography
        variant={"subtitle1"}
        sx={{
          color: style.color || theme.palette.secondary.main,
          padding: style.padding || "15px 13px",
          fontSize: style.fontSize,
        }}
      >
        {content}
      </Typography>
      {status && (
        <Button
          sx={{
            fontSize: "20px",
            fontWeight: "bold",
            textAlign: "center",
            background: handleStatusColor(status),
            padding: "4px 36px",
            borderRadius: "0px",
            color: theme.palette.common.white,
            textTransform: "capitalize",
            width: "100px",
            margin: "7px 10px 7px 0px",

            "&:hover": {
              background: handleStatusColor(status),
            },
          }}
        >
          {status}
        </Button>
      )}
    </Box>
  );
};

export default CustomBox;
